import { IInquiryUpdate } from './inquiry-update.interface';
import { IInquiry } from './inquiry.interface';
import { IMessageUpdate } from './message-update.interface';
import { IMessage } from './message.interface';

export enum SocketEventEnum {
  connect = 'connect',
  connectError = 'connect_error',
  disconnect = 'disconnect',
}

export enum SocketEventKeyEnum {
  createInquiry = 'createInquiry',
  createReply = 'createReply',
  readInquiry = 'readInquiry',
  completeInquiry = 'completeInquiry',
  updateWatchingState = 'updateWatchingState',
  updateTypingState = 'updateTypingState',
}

export interface IOnCreateInquiry {
  key: SocketEventKeyEnum.createInquiry;
  senderInquiry: IInquiry;
  recipientInquiries: IInquiry[];
  message: IMessage;
}

export interface IOnCreateReply {
  key: SocketEventKeyEnum.createReply;
  senderInquiry: IInquiryUpdate;
  recipientInquiries: IInquiryUpdate[];
  message: IMessage;
}

export interface IOnReadInquiry {
  key: SocketEventKeyEnum.readInquiry;
  inquiry: IInquiryUpdate;
  messages: IMessageUpdate[];
}

export interface IOnCompleteInquiry {
  key: SocketEventKeyEnum.completeInquiry;
  inquiries: IInquiryUpdate[];
}

export interface IOnUpdateTypingState {
  listeningEventType: 'focus' | 'blur';
  emitUserId: string;
  inquiryId: string;
}
